export default __webpack_public_path__ + "static/media/message.32a62ab4.svg";